import { HarpValidators } from '@shared/utils/validators';
import { TEXT_CONSTANTS } from '@shared/constants';

export const NEW_PASSWORD_VALIDATORS = passwordRegex => [
  HarpValidators.required(
    TEXT_CONSTANTS.ERROR_MESSAGE_REQUIRED('New Password'),
  ),
  HarpValidators.pattern(passwordRegex, 'Invalid Password'),
];

export const CONFIRM_NEW_PASSWORD_VALIDATORS = (password = '') => [
  HarpValidators.required(
    TEXT_CONSTANTS.ERROR_MESSAGE_REQUIRED('Confirm New Password'),
  ),
  HarpValidators.mustEqual(password, 'Your passwords must match'),
];
